import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';
import { smoothScroll } from './1.3_smooth-scroll.js';
import ProgressBar from 'progressbar.js';

const SECTION_ID = 'about-page-section-e';
const DESKTOP_CLASS = 'desktop';
const HEADING_CLASS = 'heading';
const HEADING_WRAPPER_CLASS = 'heading-wrapper';
const CONTAINER_WRAPPER_CLASS = 'container-wrapper';
const HEADING_INNER_WRAPPER_CLASS = 'heading-inner-wrapper';
const TEXT_CLASS = 'text';
const PROGRESS_INDICATOR_OPACITY = 0.2;
const PROGRESS_INDICATOR_ID = 'progress-indicator';

class AnimationsAboutSectionE {
    constructor() {
        this._section = document.getElementById(SECTION_ID);

        this._section && this._run();
    }
    _run = () => {
        this._media = gsap.matchMedia();
        this._desktop = this._section.querySelector(`.${DESKTOP_CLASS}`);
        this._containerWrapper = this._desktop.querySelector(`.${CONTAINER_WRAPPER_CLASS}`);
        this._heading = this._desktop.querySelectorAll(`.${HEADING_CLASS}`);
        this._headingWrapper = this._desktop.querySelector(`.${HEADING_WRAPPER_CLASS}`);
        this._headingInnerWrapper = this._desktop.querySelector(`.${HEADING_INNER_WRAPPER_CLASS}`);
        this._text = this._desktop.querySelectorAll(`.${TEXT_CLASS}`);
        this._interval = parseInt(this._desktop.dataset.interval);
        this._count = parseInt(this._desktop.dataset.count);
        this._currProgress = 0;
        this._sectionActive = false;

        this._progressIndicatorElement = document.getElementById(PROGRESS_INDICATOR_ID);

        this._headingWrapper.style.height = getComputedStyle(this._heading[0]).height;
        this._heading.forEach((heading) => {
            heading.classList.remove('absolute');
        });

        this._initProgressIndicator();

        this._media.add(
            {
                isDesktop: `(min-width: ${screenSm}px)`,
                isMobile: `(max-width: ${screenSm - 1}px)`,
                reduceMotion: '(prefers-reduced-motion: reduce)',
            },
            this._createAnimationTimeline,
        );
    };
    _initProgressIndicator = () => {
        if (this._progressIndicatorElement) {
            this._progressIndicator = new ProgressBar.Circle(this._progressIndicatorElement, {
                strokeWidth: 50,
                easing: 'linear',
                duration: this._interval * 1000,
                color: '#ffffff',
                trailColor: '#474747',
                trailWidth: 0,
                svgStyle: null,
            });
        }
    };
    _startProgressIndicator = () => {
        this._progressIndicator.animate(1);
    };
    _pauseProgressIndicator = () => {
        this._progressIndicator.stop();
    };
    _resetProgressIndicator = () => {
        this._progressIndicator.set(0);
    };

    _createAnimationTimeline = (context) => {
        let { isDesktop, isMobile, reduceMotion } = context.conditions;

        let prevIndex = 0;
        let currIndex = 0;
        let count = 2;

        let ticker = false;

        let startRotator = () => {
            if (!ticker) {
                this._progressIndicatorElement.classList.remove('opacity-0');
                this._progressIndicatorElement.style.opacity = PROGRESS_INDICATOR_OPACITY;
                this._resetProgressIndicator();
                this._startProgressIndicator();
                ticker = setInterval(() => {
                    this._resetProgressIndicator();
                    this._startProgressIndicator();
                    prevIndex = currIndex;
                    currIndex = count;
                    let ease = 'power3.inOut';
                    let duration = 1.2;
                    if (prevIndex !== currIndex && (currIndex - 1 >= 0 || currIndex - 1 <= -100)) {
                        gsap.to(this._headingInnerWrapper, {
                            yPercent: -((100 / this._count) * (currIndex - 1)),
                            duration: duration,
                            ease: ease,
                        });

                        let tl = gsap.timeline({
                            defaults: {
                                duration: duration / 2,
                                ease: ease,
                            },
                        });

                        this._text[currIndex - 2] &&
                            tl.to(this._text[currIndex - 2], {
                                opacity: 0,
                            });
                        this._text[currIndex - 1] &&
                            tl.to(this._text[currIndex - 1], {
                                opacity: 1,
                                onUpdate: () => {
                                    this._text.forEach((text) => {
                                        if (text !== this._text[currIndex - 1]) {
                                            gsap.set(text, {
                                                opacity: 0,
                                            });
                                        }
                                    });
                                },
                            });
                    }

                    if (count === this._count) {
                        count = 1;
                    } else {
                        count++;
                    }
                }, this._interval * 1000);
            }
        };
        let pauseRotator = () => {
            clearInterval(ticker);
            ticker = false;
            this._progressIndicatorElement.style.opacity = 0;
        };
        this._animation1 = gsap.timeline({
            scrollTrigger: {
                trigger: this._desktop,
                start: '-=50% top',
                end: '50% top',
                markers: false,
                onLeave: () => {
                    pauseRotator();
                    this._sectionActive = false;
                },
                onEnterBack: () => {
                    startRotator();
                    this._sectionActive = true;
                },
                onLeaveBack: () => {
                    pauseRotator();
                    this._sectionActive = false;
                },
                onEnter: () => {
                    startRotator();
                    this._sectionActive = true;
                },
            },
        });
        // document.addEventListener('visibilitychange', () => {
        //     if (document.visibilityState === 'hidden') {
        //         pauseRotator();
        //     } else if (document.visibilityState === 'visible') {
        //         if (this._sectionActive) {
        //             startRotator();
        //         }
        //     }
        // });
    };
}
const animationsAboutSectionE = new AnimationsAboutSectionE();
